/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Beneficiary information in a payment breakdown
 * @export
 * @interface BreakdownBeneficiaryDto
 */
export interface BreakdownBeneficiaryDto {
    /**
     * 
     * @type {string}
     * @memberof BreakdownBeneficiaryDto
     */
    legalEntityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BreakdownBeneficiaryDto
     */
    designation: string;
    /**
     * 
     * @type {string}
     * @memberof BreakdownBeneficiaryDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BreakdownBeneficiaryDto
     */
    bankAccountId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BreakdownBeneficiaryDto
     */
    bankAccountIban?: string | null;
}

/**
 * Check if a given object implements the BreakdownBeneficiaryDto interface.
 */
export function instanceOfBreakdownBeneficiaryDto(value: object): value is BreakdownBeneficiaryDto {
    if (!('designation' in value) || value['designation'] === undefined) return false;
    return true;
}

export function BreakdownBeneficiaryDtoFromJSON(json: any): BreakdownBeneficiaryDto {
    return BreakdownBeneficiaryDtoFromJSONTyped(json, false);
}

export function BreakdownBeneficiaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreakdownBeneficiaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'] == null ? undefined : json['legalEntityId'],
        'designation': json['designation'],
        'type': json['type'] == null ? undefined : json['type'],
        'bankAccountId': json['bankAccountId'] == null ? undefined : json['bankAccountId'],
        'bankAccountIban': json['bankAccountIban'] == null ? undefined : json['bankAccountIban'],
    };
}

export function BreakdownBeneficiaryDtoToJSON(json: any): BreakdownBeneficiaryDto {
    return BreakdownBeneficiaryDtoToJSONTyped(json, false);
}

export function BreakdownBeneficiaryDtoToJSONTyped(value?: BreakdownBeneficiaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'legalEntityId': value['legalEntityId'],
        'designation': value['designation'],
        'type': value['type'],
        'bankAccountId': value['bankAccountId'],
        'bankAccountIban': value['bankAccountIban'],
    };
}

